export default __webpack_public_path__ + "static/media/only.42a7ad91.meteorOrNode";